<template>
  <div>
    <v-list style="font-size:0.9rem" v-if="list.length > 0">
      <v-list-item v-for="(item,index) in list" :key="index" style="min-height:38px;max-height:38px;padding-right:0.15rem;" @click="goDetail(item)">
        <v-list-item-avatar size="24" style="padding-top:0.2rem;margin-right:0.25rem;">
          <!-- <v-img :src="item.icon"></v-img> -->
          <v-icon color="warning" style="font-size:1rem;">fa-volume-down</v-icon>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title style="font-size:0.9rem;padding-top:0.2rem;">
            <v-row style="margin:0;">
              <v-col :cols="7" style="padding:0;font-size:0.8rem;">
                <v-badge class="us-v-badge" color="#ff3b30" offset-x="-1" offset-y="2" dot v-if="item.READ_SID === 0">
                  <span>{{item.NOTIFY_TITLE}}</span>
                </v-badge>
                <span v-else>{{item.NOTIFY_TITLE}}</span>
              </v-col>
              <v-col :cols="5" style="padding:0;font-size:0.75rem;text-align:right;">
                <div style="margin-top:0.02rem;color:#9e9e9e;">
                  {{getMsgTimeFormat(item.ROW_DATE_CREATE)}}
                </div>
              </v-col>
            </v-row>
          </v-list-item-title>
        </v-list-item-content>
        <v-list-item-icon style="padding-top:0.16rem;margin-left:0.85rem;">
          <v-icon style="line-height:0px;" color="grey">fa fa-angle-right</v-icon>
        </v-list-item-icon>
      </v-list-item>
    </v-list>
    <div v-else style="text-align:center;color:#9e9e9e;font-size:0.8rem;padding:0.5rem 0 1rem;">暂无消息</div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
  },
  data() {
    return {
      loading: true,
      list: []
    }
  },
  computed: {
  },
  mounted() {
    this.initData()
  },
  created() {
  },
  methods: {
    goDetail(item) {
      if (!item.NOTIFY_URL) {
        this.$toast('页面未完成')
        return
      }
      var that = this
      that.$api.bz.setGzNotifyRead({ id: item.GZ_NOTIFY_ID }).then(res => {
        that.$router.goPage(item.NOTIFY_URL)
        setTimeout(function() {
          item.READ_SID = 2;
        }, 0.5 * 1000)
      })
    },
    initData() {
      var that = this
      // for (let index = 0; index < 2; index++) {
      //   var item = {
      //     icon: 'https://ss2.bdstatic.com/70cFvnSh_Q1YnxGkpoWK1HF6hhy/it/u=3100359545,4091150701&fm=26&gp=0.jpg',
      //     content: '您有新工单需要处理',
      //     time: that.$moment()
      //   };
      //   that.list.push(item)
      // }
      // var item1 = {
      //   icon: 'https://ss2.bdstatic.com/70cFvnSh_Q1YnxGkpoWK1HF6hhy/it/u=3100359545,4091150701&fm=26&gp=0.jpg',
      //   content: '您有新工单需要处理',
      //   time: '2020-08-01 13:49:34'
      // };
      // that.list.push(item1)
      that.$api.bz.getGzNotifyLast().then(res => {
        if (!res.success) {
          console.log('获取最近3条通知失败', res);
          return
        }
        var data = res.data
        that.list = data
        that.loading = false
      })
    },
    // 格式化时间显示
    getMsgTimeFormat(time) {
      var that = this
      var mt = that.$moment(time)
      var tv = mt.format('YYYY-MM-DD')
      var now = that.$moment(new Date()).format('YYYY-MM-DD')
      if (tv < now) {
        var zt = that.$moment(new Date()).add(-1, 'days').format('YYYY-MM-DD')
        if (zt === tv) {
          return mt.format('昨天 HH:mm')
        }
        return mt.format('YYYY-MM-DD HH:mm')
      }
      return mt.format('HH:mm')
    }
  }
}
</script>

<style scoped>
.us-v-badge >>> .v-badge__badge{
  height: 0.33rem !important;
  width: 0.33rem !important;
}
</style>

